<template>
  <header class="card_title" :class="[{'end': isShowClose}, {'no-border': isNoBorder}]">
    <p class="text_color_primary text_size_18 text_bold" :title="title">
      <slot></slot>
    </p>
    <i @click="close" v-if="isShowClose" class="iconfont iconshanchu close"></i>
  </header>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    isShowClose: {
      type: Boolean,
      default: false
    },
    isNoBorder: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    close () {
      this.$emit('close')
    }
  }
}
</script>
<style lang="scss" scoped>
  .card_title {
    flex: none;
    width: 100%;
    height: 60px;
    text-align: left;
    line-height: 60px;
    border-bottom: 1px solid $border-color-base;
    color: $color-text-primary;
  }
  .end {
    display: flex;
    justify-content: space-between;
  }
  .close {
    font-size: 18px;
    cursor: pointer;
    transition: all 0.3s ease;
    &:hover {
      color: $color-primary;
    }
  }
  .no-border {
    border: 0px;
  }
</style>



// WEBPACK FOOTER //
// src/components/border-title.vue